import { html, render } from 'lit/html.js'
import { styleMap } from 'lit/directives/style-map.js'
import { StateElement } from '../unit-base'
import '../unit-svg/'

const signature = `
Element will change color on click and can display icon1 and icon2.

### Set State with Attributes and Properties
\`\`\`javascript
document.querySelector("unit-button").state = {
  // Attributes
  "id": null,
  "label":"Label",
  "value": "value",
  "hidden": false,
  "disabled": false,
  "selected": false,
  "href": "link", // use only for link-button
  "info": ["info label", ... ], // use only for button with info
  // Properties
  "height": "3rem",
  "width": null,
  "icon1": null,
  "icon2": null
  "font-size": "1.2rem",
  "padding": "1rem 2rem"
}
\`\`\`

### Events
\`\`\`javascript
document.querySelector("unit-svg").addEventListener("action", (e) => {
  // { value: value, label: label, selected: selected, origin: main }
  console.log(e.detail)
})
\`\`\`
`

export default class Button extends StateElement {

  constructor() {
    super()
  }

  static get signature() {
    return signature.trim()
  }

  static get observedAttributes() {
    return [ "id", "value", "hidden", "disabled", "label", "width", "height", "selected", "href", "info", "icon1", "icon2" ]
  }

  template( data ) {
    const value = data.value || ""
    const label = data.label || ""

    const onAction = ( e ) => {
      e.stopPropagation()
      e.preventDefault()
      // Check origin
      const origin = e.type == "action" ? e.target.className : "main"
      // Dispatch parent with state
      this.dispatchEvent( new CustomEvent( "action", {
        bubbles: true,
        detail: { value: this.state.value, label: this.state.label, selected: this.state.selected, origin: "main" }
      } ) )
    }

    const style = {
      // As long as width and height are not set
      // they will grow according to children
      "width": data[ "width" ],
      "padding": data.padding || "1rem 2rem",
      "height": `calc( ${data[ "height" ] || "2.5rem"})`
    }

    const icon1 = !data.icon1 ? null : typeof data.icon1 == "string" ? { src: data.icon1 } : data.icon1
    const icon2 = !data.icon2 ? null : typeof data.icon2 == "string" ? { src: data.icon2 } : data.icon2

    if ( data.href != null ) {
      return html `<a class="link" @click="${onAction}" style="${styleMap(style)}" href="${data.href}" value="${value}">
      ${ icon1
        ? html `<unit-svg class="icon1" .state=${icon1}></unit-svg>`
        : ``
      }
      ${label}
      </a>`
    }
    if ( data.info != null ) {
      return html `
        <section @click="${onAction}" style="${styleMap(style)}" value="${value}">
          ${ icon1
            ? html `<unit-svg class="icon1" .state=${icon1}></unit-svg>`
            : ``
          }
          <span class=name>${ label }</span>
          ${ icon2
            ? html `<unit-svg class="icon2" .state=${icon2}></unit-svg>`
            : ``
          }
        </section>
        <div class="info-labels">
        ${
          (data.info).split(",").map( item => {
            return html `
              <div @click="${onAction}" value="${item}"><a><p>${item}</p></a></div>
            `
          } )
        }
        </div>
      `
    } else {
      return html `
        <section @click="${onAction}" style="${styleMap(style)}" value="${value}">
          ${ icon1
            ? html `<unit-svg class="icon1" .state=${icon1}></unit-svg>`
            : ``
          }
          <span class=name>${ label }</span>
          ${ icon2
            ? html `<unit-svg class="icon2" .state=${icon2}></unit-svg>`
            : ``
          }
        </section>
      `
    }
  }

}